<template>
  <div id="app">
    <header>
        <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <div class="container">

          <a class="navbar-brand" href="#">
          <img src="/logo1.png" width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy">
          <!-- <img src="https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/05/Target_Corporation_logo_vector.svg.png?auto=format&q=60&fit=max&w=930" width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy"> -->
          DEVSITERULES OK</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse mr-sm-2" id="navbarCollapse">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item active">
                <!-- <router-link to="/"> -->
                <router-link to="/" data-toggle="collapse" data-target="#navbarCollapse.show" class="nav-link" href="#">Home <span class="sr-only">(current)</span></router-link>
              </li>
              <li class="nav-item">
                <router-link to="/about" data-toggle="collapse" data-target="#navbarCollapse.show" class="nav-link">About Us</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/carlist" data-toggle="collapse" data-target="#navbarCollapse.show" class="nav-link">Our Cars</router-link>
              </li>
              <!-- <li class="nav-item">
                <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
              </li> -->
            </ul>
            <!-- <form class="form-inline mt-2 mt-md-0">
              <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search">
              <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
            </form> -->
          </div>
        </div>
      </nav>
    </header>

    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
  </div>
</template>
<script>

export default {
  name: 'home-app',
  methods: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.nav-link.router-link-exact-active.router-link-active {
  color: red !important;
  font-weight: bold;
}

.carousel-item {
   height: unset !important;
}
</style>
